export const FILE = 'common.file';
export const BTN_SEND = 'common.btn.send';
export const BTN_CANCEL = 'common.btn.cancel';
export const CLOSE = 'common.btn.close';
export const OK = 'common.ok';
export const RETRY = 'common.retry';
export const EMAIL = 'common.email';
export const ENTER_EMAIL_ADDRESS = 'common.enter-email-address';
export const PLEASE_SELECT = 'common.please-select';
export const SECURE_SSL_CONNECTION = 'common.secure-ssl-connection';
export const SEND_EMAIL = 'common.btn.send-email';
export const LEAVE = 'common.btn.leave';
export const SEND_FILE = 'chat.caller.tooltip.send-file';
export const PRINT_TRANSCRIPT = 'chat.caller.tooltip.print-transcript';
export const SEND_TRANSCRIPT = 'chat.caller.tooltip.send-transcript-by-email';
export const TRANSFERRED = 'chat.caller.send-file.transferred';
export const SELECT_FILE = 'chat.caller.send-file.select-file-to-send';
export const SEND_FILE_FAIL = 'chat.caller.send-file.fail';
export const FILE_SIZE_EXCEEDED = 'chat.caller.send-file.size-exceeded';
export const TRANSFER_INTERRUPTED = 'chat.caller.send-file.transfer-interrupted';
export const NEW_MESSAGE_SOUND_ALERT_ON_OFF = 'chat.caller.tooltip.new-message-sound-alert-on-off';
export const POWERED_BY = 'powered-by';
export const DIRECTION = 'common.direction';
